export const analysis = {
    labels: {
        elapsed_time: "Elapsed time",
        risk_degree: "Risk Degree",
    },
    modal: {
        titles: {
        },
        messages: {
        },
    },
    texts: {
        cancel_analysis: "Do you want to <strong>CANCEL</strong> this Analysis?<br>This operation cannot be undone!",
        finish_analysis: "Do you want to <strong>END</strong> test Analysis?<br>This operation cannot be undone!",
        start_analysis: "Do you want to <strong>START</strong> this Analysis?<br>This operation cannot be undone!",
        empty_form: "You did not add a FORM to the Analysis!",
        empty_employee: "You did not add an EMPLOYEE to the Analysis!",
        empty_sample: "You did not add a SAMPLE to the Analysis!",
        empty_method: "You did not add a METHOD to the Analysis!",
        empty_equipment: "You didn't add an EQUIPMENT to the Analysis!",
        empty_signature: "You did not add a SIGNATURE to the Analysis!",
    },
};
